/* SmartLinkSourceRow.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner/spinner';
import { ProviderIconView } from '@atlassian/conversation-assistant-utils/ProviderIconView';
import { useSmartLinkMetadata } from '@atlassian/conversation-assistant-utils/useSmartLinkMetadata';
type SmartLinkSourceRowProps = {
  /** The URL to resolve via the SmartLink store. */
  url: string;
  /** Shown while resolving or when resolution fails. */
  fallback: string;
  /**
   * Optional user-provided display text (e.g. the value the user typed into
   * the link picker's "Display text" field). When set and non-empty, it
   * takes precedence over the SmartLink-resolved title and the `fallback`.
   * The provider icon is still resolved from the SmartLink store.
   */
  displayTextOverride?: string;
};
export const SmartLinkSourceRow = ({
  url,
  fallback,
  displayTextOverride
}: SmartLinkSourceRowProps): React.JSX.Element => {
  const {
    title,
    providerIcon,
    status
  } = useSmartLinkMetadata(url);

  // While resolving, prefer to show the user-provided display text immediately
  // (with no spinner) - it's already the "right" label and we don't need to
  // wait on the SmartLink response. Only show the spinner when we have nothing
  // to display yet.
  const trimmedOverride = displayTextOverride?.trim();
  if (status === 'pending' && !trimmedOverride) {
    return <Spinner size="small" />;
  }
  const displayedTitle = trimmedOverride || title || fallback;
  return <React.Fragment>
			<ProviderIconView icon={providerIcon} />
			<Text>{displayedTitle}</Text>
		</React.Fragment>;
};